/* unplugin-vue-components disabled */import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=e34fbf8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e34fbf8e"]])

export default __exports__